import { combineReducers } from '@reduxjs/toolkit'

import conversations from './slices/conversationsSlice'

export default combineReducers({ conversations })
